export default "__VITE_ASSET__BiwLvO8L__"